import { useEffect, useState } from 'react';
import { CandidateStatus, CandidateStatusMapper } from '../../../../../../domain/PermanentJobs';
import debounceHook from '../../../../../commonComponents/debounceHook';
import { CustomSelect } from '../../../../UsersList/components/CustomSelect';

export const Filters = ({ filters, handleFilterChanged }) => {
  const [searchCandidateName, setSearchCandidateName] = useState(filters?.name || '');
  const debouncedSearchText = debounceHook(searchCandidateName, 1000);

  useEffect(() => {
      handleFilterChanged('name', searchCandidateName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchText]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <p>Candidate Name:</p>
        <input
          style={{
            paddingLeft: '8px',
            fontFamily: 'Nunito-Regular',
            width: 250,
            height: 32,
          }}
          placeholder="Search by candidate name"
          value={searchCandidateName}
          onChange={(event) => setSearchCandidateName(event.target.value)}
        />
      </div>

      <CustomSelect
        key="status"
        id="status"
        label="Candidate Status"
        options={[
          { code: '', name: 'All' },
          ...Object.values(CandidateStatus).map((status) => ({
            code: status,
            name: CandidateStatusMapper.toHumanReadable(status),
          })),
        ]}
        value={filters?.status || ''}
        onChange={handleFilterChanged}
      />
    </div>
  );
};
